<template>
	<div id="navbar">
		<ul style="padding:0;margin:0;">
		    <li class="dh2" @click="sy" :class="{active:'首页'== mesg}">
		        <a>首页</a>
		    </li>
		    <li class="dh2">
		        <a >IT工具</a>
		        <ul class="dh3">
		            <li v-for="mesg in navinfo[0]['it']" :key="mesg" @click="isclick(mesg)">
		                <a>{{mesg}}</a>
		            </li>
		            
		        </ul>
		    </li>
		    <li class="dh2">
		        <a >游戏助手</a>
		        <ul class="dh3">
		            <li v-for="mesg in navinfo[1]['game']" :key="mesg" @click="isclick(mesg)">
		                <a>{{mesg}}</a>
		            </li>
		        </ul>
		    </li>
		    <li class="dh2">
		        <a >教程专区</a>
		        <ul class="dh3">
		            <li v-for="mesg in navinfo[2]['jczq']" :key="mesg" @click="isclick(mesg)">
		                <a>{{mesg}}</a>
		            </li>
	
		        </ul>
		    </li>
		    <li class="dh2">
		        <a >资源专区</a>
		        <ul class="dh3">
		           <li v-for="mesg in navinfo[3]['zyzq']" :key="mesg" @click="isclick(mesg)">
		               <a>{{mesg}}</a>
		           </li>
		        </ul>
		    </li>
		    <li class="dh2">
		        <a >实用软件</a>
		        <ul class="dh3">
		            <li v-for="mesg in navinfo[4]['syrj']" :key="mesg" @click="isclick(mesg)">
		                <a>{{mesg}}</a>
		            </li>
		        </ul>
		    </li>
		    <li class="dh2">
		        <a >公告专区</a>
		        <ul class="dh3">
		            <li v-for="mesg in navinfo[5]['gongg']" :key="mesg" @click="isclick(mesg)">
		                <a>{{mesg}}</a>
		            </li>
		        </ul>
		    </li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'navbar',
		data(){
			return{
				navinfo:[
					{"it" :['编程工具','Hive工具','Mysql工具']},
					{"game" :['穿越火线',"英雄联盟",'QQ飞车','DNF','csgo','其它辅助']},
					{"jczq":['游戏攻略','自我提升',"编程办公","两性相关","其他教程"]},
					{"zyzq" :['网站源码','PSD源码','各类源码','微信技巧','qq技巧','其他技巧']},
					{"syrj" :['安卓软件','电脑软件']},
					{"gongg" :['关于我们','公告通知']}
				],
				mesg:'',
			}
		},
		//每次进入判断一次是否给首页选中效果
		mounted() {
			if(this.$route.path=='/home'){
				this.mesg='首页'
			}
		},
		//如果不是首页则需要给父级发射网络请求
		methods:{
			isclick(mesg){
				if(this.$route.path=='/home/'+mesg){
					
				}else{
					this.$router.push('/home/' + mesg)		
					this.$emit('getinfo',mesg)
				}
			},
			
			//判断如果是不是首页，如果不是首页则需要跳转到首页
			sy(){
				if(this.$route.path=='/home'){
					this.mesg='首页'
				}else{
					this.$router.push('/home')
			  }
			}
		}
	}
</script>

<style scoped>
	#navbar{
	    height: 43px;
	    margin-top: 10px;
	    text-align: center;
	}
	.dh2{
	    width: 14.28%;
	    font-size: 22px;
	    float: left;
	    text-align: center;
	    color: rgb(63, 62, 62);
	    display:block;
	    position:relative;
	}
	.dh2 a{
	    display: block;
	    height: 40px;
	    line-height: 40px;
	    text-decoration: none;
	    color: rgb(244, 243, 243);
	    background:#00a5f8;
	    
	}
	.dh3{
	    display:none;
	    z-index: 999;
	    /* border: solid 2px #3287f6; */
	    position:absolute;
	    width: 100%;
	}
	.dh3 li{
	    width: 100%;
	    font-weight: normal;
	    position: relative;
	    font-size: 14px
	}
	.dh3 li a{
	    height: 40px;
	    text-decoration: none;
	    color: rgb(63, 62, 62);
	    background:#e5e5e5;
	    position: relative;
	}
	.dh2 a:hover{
	    background: #4e9dec;
	    color: rgb(234, 233, 233);
	    font-weight: bold;
	}
	.dh2:hover .dh3{
	    display: block;
	}
	
	.active{
	    background: #3287f6;
	    color:  rgb(235, 235, 235);
	    font-weight: bold;
	}
	.active a{
		background: #3287f6;
		color:  rgb(235, 235, 235);
		font-weight: bold;
	}
</style>